export const REVIEW_RESULTS_STORAGE_KEY = 'courtyard_review_results';
export const REVIEW_COMPLETE_STATE_STORAGE_KEY = 'courtyard_review_complete_state';
